import { useState, type ReactNode } from 'react';

type Props = {
  content: string;
  maxChars?: number;
  className?: string;
};

function ToggleButton({
  open,
  onClick,
}: {
  open: boolean;
  onClick: () => void;
}): ReactNode {
  return (
    <button
      type="button"
      onClick={onClick}
      className="mt-xs text-xs font-medium text-brand-red hover:underline"
    >
      {open ? 'Ver menos' : 'Ver más'}
    </button>
  );
}

export function ExpandableText({
  content,
  maxChars = 200,
  className,
}: Props): ReactNode {
  const [open, setOpen] = useState(false);
  if (!content) return null;
  const isLong = content.length > maxChars;
  const visible = open || !isLong ? content : content.slice(0, maxChars) + '…';
  return (
    <div className={className}>
      <p className="whitespace-pre-wrap text-xs text-text-secondary">
        {visible}
      </p>
      {isLong && (
        <ToggleButton open={open} onClick={() => setOpen((v) => !v)} />
      )}
    </div>
  );
}
